import { Component, OnInit } from '@angular/core';
import { InquireTransactionService } from '../shared/services/InquireTransaction.service';
import { BillAvailableBalanceService } from '../shared/services/payWithBalance.service';
import { FetchSellerBalanceService } from '../../financials/services/fetch-seller-balance.service';
import { Router } from '@angular/router';
import { isInquirableService } from '../shared/services/isInquirable.service';
import { prepareNonInquireTransaction } from '../shared/services/prepareNonInquireTransaction.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-balance-pay',
  templateUrl: './balance-pay.component.html',
  styleUrls: ['./balance-pay.component.scss'],
})
export class BalancePayComponent implements OnInit {
  balance: any;
  availableBalance: number;
  billAmount: number;
  trxParams: any;
  success: boolean;
  isInquirable: boolean;
  status:string;
  errorMsg = "Something wrong happened please try again later.";
  constructor(
    private inquireTransaction: InquireTransactionService,
    private getbalance: FetchSellerBalanceService,
    private router: Router,
    private BillWithBalance: BillAvailableBalanceService,
    private isInquirableService: isInquirableService,
    private nonInquirableService: prepareNonInquireTransaction
  ) {
    this.success = false;
    this.isInquirableService.isinquirableState.subscribe((res) => {
      this.isInquirable = res;
    });
  }

  async ngOnInit() {
    await this.updateBalance();
    this.billAmount = this.isInquirable
      ? this.inquireTransaction.trxInquiryResponse.data.amount
      :+this.nonInquirableService.totalAmount;
  }
  back(): void {
    this.router.navigate(['/seller/billPayments']);
  }
  async pay() {
    try {
      if (this.isInquirable) {
        this.trxParams = this.inquireTransaction.getParams();
        const trx = {
          amount: this.billAmount,
          RefNum: this.inquireTransaction.trxInquiryResponse.RefNum,
          billerService: this.trxParams.billerService,
          input_parameter_list: this.trxParams.input_parameter_list,
        };
        this.BillWithBalance.setParams(trx);
        const res = await this.BillWithBalance.make();
        if (res.status === 'SUCCESS') {
          this.success = true;
          this.status = "SUCCESS"
          await this.updateBalance();
        }
        else {
          this.status = 'FAILED'
          Swal.fire({
            title: "Oops",
            text:  this.errorMsg,
            icon: 'warning',
          }).then((result)=>{
            this.back();
          })
        }
      } else {
        this.trxParams = this.nonInquirableService.getParams()
        const trx = {
          amount:+this.nonInquirableService.nonInqtrxResponse.amount,
          RefNum :this.nonInquirableService.nonInqtrxResponse.RefNum,
          billerService : this.nonInquirableService.nonInqtrxResponse.billerService,
          input_parameter_list : this.trxParams.input_parameter_list
        };
        this.BillWithBalance.setParams(trx);
        const res = await this.BillWithBalance.make();
        if (res.status === 'SUCCESS') {
          this.status = "SUCCESS"
          this.success = true;
          await this.updateBalance();
        }
        else {
          this.status = 'FAILED'
          Swal.fire({
            title: "Oops",
            text:  this.errorMsg,
            icon: 'warning',
          }).then((result)=>{
            this.back();
          })
        }
      }
    } catch (err) {
      this.status = 'FAILED';
      if(err.faultyRequest.error.status === "ERROR" && err.faultyRequest.error.error){
        this.errorMsg = err.faultyRequest.error.error;
      }
      Swal.fire({
        title: "Oops",
        text:  this.errorMsg,
        icon: 'warning',
      }).then((result)=>{
        this.back();
      })
      console.log(err);
    }
  }
  async updateBalance (){
    this.balance = await this.getbalance.make();
    this.availableBalance = this.balance.avalibleBalance;
  }
}
